import { useEffect, useState } from "react";
import Routes from "../routes";

const useGetCountryDropdowns = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({ countries : [], states:[]});

  const fetchOptionData = async () => {
    try {
      setIsLoading(true);
      const requestGetCountryDropDown = await fetch(
        Routes.Location.CountryDropdowns()
      );
      const response = await requestGetCountryDropDown.json();
      const countries = response.countries.map(
        ({ value, name }) => ({
          value: value,
          name: name,
        })
      );
      const states = response.states.map(
        ({ value, name, countryCode }) => ({
          value: value,
          name: name,
          countryCode: countryCode
        })
      );
      setData({
        countries,
        states
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptionData();
  }, []);

  return {
    isLoading,
    countries: data.countries,
    states: data.states
  };
};

export default useGetCountryDropdowns;
